<div class="modal fade confirmation" (keypress)="modalBackdrop($event)" id="{{uniqueId+'confirmModal'}}" tabindex="-1"
  role="alertdialog" aria-hidden="true" aria-modal="true"
  aria-describedby="globalDialogTitleConfirm globalDialogMsgConfirm">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <h2 *ngIf="!onlyOk" id="globalDialogTitleConfirm" class="font-bold confirmation-heading text-danger mb-3">
          Attention!</h2>
        <h2 *ngIf="onlyOk" id="globalDialogTitleConfirm" class="font-bold confirmation-heading text-danger mb-3">
          {{title}}</h2>
        <p id="globalDialogMsgConfirm" class = "text-break" [innerHtml]="message"></p>
        <hr aria-hidden="true" tabindex="-1">

        <div class="col-12 d-flex justify-content-center">
          <div class="col-auto p-0">
            <!-- for the no button -->
            <button data-dismiss="modal" *ngIf="!onlyOk" type="button" class="btn btn-danger px-4 mr-2 btn-highcontrast"
              id="{{uniqueId + btnCancelText }}BtncdConfirm" (click)="decline()">{{btnCancelText }}</button>
            <br>
            <!-- dont remove this br. this is a hack for the accessibility -->
          </div>

          <div class="col-auto p-0">
            <!-- for the yes button -->
            <button data-dismiss="modal" type="button" id="{{uniqueId +  btnOkText }}BtncdConfirm"
              class="btn btn-primary px-4 btn-highcontrast" (click)="onlyOk ? decline() : accept()">
              <span>{{ btnOkText }}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
